/**
 * DEPŪ STUDIOS — Premium Product Image Viewer
 * Navigation, zoom controls, keyboard, scroll, pinch, drag
 */
(function () {
  'use strict';

  var MIN_SCALE = 1;
  var MAX_SCALE = 5;
  var ZOOM_STEP = 0.4;
  var DBL_TAP = 300;

  function initViewer(modal) {
    if (modal._viewerInit) return;
    modal._viewerInit = true;

    var content = modal.querySelector('.product-media-modal__content');
    var zoomLabel = modal.querySelector('.ds-viewer__zoom-level');
    var counterLabel = modal.querySelector('.ds-viewer__counter');
    var thumbStrip = modal.querySelector('.ds-viewer__thumbs');
    var hintEl = modal.querySelector('.ds-viewer__kbd-hint');
    if (!content) return;

    var scale = 1, panX = 0, panY = 0;
    var isPanning = false, startX = 0, startY = 0, startPanX = 0, startPanY = 0;
    var lastTap = 0, pinchDist0 = 0, pinchScale0 = 1;
    var swipeStartX = 0, swipeStartY = 0, swiping = false;

    // ── Helpers ──
    function getAllMedia() {
      return Array.from(content.querySelectorAll('[data-media-id]'));
    }

    function getActiveMedia() {
      return content.querySelector('[data-media-id].active') || getAllMedia()[0];
    }

    function getActiveImg() {
      var el = getActiveMedia();
      return el ? el.querySelector('img') || el : null;
    }

    function getIndex() {
      var all = getAllMedia();
      var active = getActiveMedia();
      return active ? all.indexOf(active) : 0;
    }

    function updateCounter() {
      var all = getAllMedia();
      var idx = getIndex();
      if (counterLabel) counterLabel.textContent = (idx + 1) + ' / ' + all.length;
      // Update thumbnails
      if (thumbStrip) {
        var thumbs = thumbStrip.querySelectorAll('.ds-viewer__thumb');
        thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === idx); });
      }
      // Update nav arrows
      var prev = modal.querySelector('.ds-viewer__nav--prev');
      var next = modal.querySelector('.ds-viewer__nav--next');
      if (prev) prev.disabled = idx <= 0;
      if (next) next.disabled = idx >= all.length - 1;
    }

    function updateZoomLabel() {
      var pct = Math.round(scale * 100) + '%';
      if (zoomLabel) {
        zoomLabel.textContent = pct;
        zoomLabel.classList.toggle('is-zoomed', scale > 1);
      }
    }

    function clampPan(img) {
      if (!img) return;
      var dw = img.offsetWidth * scale;
      var dh = img.offsetHeight * scale;
      var cw = content.clientWidth;
      var ch = content.clientHeight;
      if (dw <= cw) { panX = 0; } else { var mx = (dw - cw) / 2; panX = Math.max(-mx, Math.min(mx, panX)); }
      if (dh <= ch) { panY = 0; } else { var my = (dh - ch) / 2; panY = Math.max(-my, Math.min(my, panY)); }
    }

    function applyTransform(img) {
      if (!img) return;
      img.style.transform = 'translate(' + panX + 'px,' + panY + 'px) scale(' + scale + ')';
      updateZoomLabel();
      content.classList.toggle('is-zoomed', scale > 1);
    }

    function resetZoom(smooth) {
      scale = 1; panX = 0; panY = 0;
      var img = getActiveImg();
      if (img) {
        if (smooth) img.style.transition = 'transform 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94)';
        img.style.transform = '';
        if (smooth) setTimeout(function () { img.style.transition = ''; }, 350);
      }
      content.classList.remove('is-zoomed');
      updateZoomLabel();
    }

    function zoomTo(newScale, cx, cy, smooth) {
      var img = getActiveImg();
      if (!img) return;
      var old = scale;
      scale = Math.max(MIN_SCALE, Math.min(MAX_SCALE, newScale));
      if (scale <= 1) { panX = 0; panY = 0; }
      else if (cx !== undefined && cy !== undefined) {
        var r = img.getBoundingClientRect();
        var ox = cx - r.left - r.width / 2;
        var oy = cy - r.top - r.height / 2;
        var ratio = 1 - scale / old;
        panX += ox * ratio;
        panY += oy * ratio;
      }
      clampPan(img);
      if (smooth) img.style.transition = 'transform 0.25s cubic-bezier(0.25, 0.46, 0.45, 0.94)';
      applyTransform(img);
      if (smooth) setTimeout(function () { img.style.transition = ''; }, 280);
    }

    // ── Navigate ──
    function goTo(idx) {
      var all = getAllMedia();
      if (idx < 0 || idx >= all.length) return;
      resetZoom(false);
      all.forEach(function (el) { el.classList.remove('active'); });
      all[idx].classList.add('active');
      // Reset transform on new image
      var img = all[idx].querySelector('img');
      if (img) img.style.transform = '';
      updateCounter();
    }

    function goPrev() { goTo(getIndex() - 1); }
    function goNext() { goTo(getIndex() + 1); }

    // ── Arrow buttons ──
    modal.querySelectorAll('.ds-viewer__nav').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        btn.getAttribute('data-dir') === 'prev' ? goPrev() : goNext();
      });
    });

    // ── Thumbnail clicks ──
    if (thumbStrip) {
      thumbStrip.addEventListener('click', function (e) {
        var thumb = e.target.closest('.ds-viewer__thumb');
        if (!thumb) return;
        var mid = thumb.getAttribute('data-thumb-media-id');
        var all = getAllMedia();
        for (var i = 0; i < all.length; i++) {
          if (all[i].getAttribute('data-media-id') === mid) { goTo(i); break; }
        }
      });
    }

    // ── Zoom control buttons ──
    modal.querySelectorAll('[data-zoom-action]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        var action = btn.getAttribute('data-zoom-action');
        if (action === 'in') zoomTo(scale + ZOOM_STEP * 2, undefined, undefined, true);
        else if (action === 'out') zoomTo(scale - ZOOM_STEP * 2, undefined, undefined, true);
        else if (action === 'fit') resetZoom(true);
      });
    });

    // ── Keyboard ──
    function onKey(e) {
      if (!modal.hasAttribute('open')) return;
      switch (e.key) {
        case 'ArrowLeft': e.preventDefault(); goPrev(); break;
        case 'ArrowRight': e.preventDefault(); goNext(); break;
        case '+': case '=': e.preventDefault(); zoomTo(scale + ZOOM_STEP, undefined, undefined, true); break;
        case '-': case '_': e.preventDefault(); zoomTo(scale - ZOOM_STEP, undefined, undefined, true); break;
        case '0': e.preventDefault(); resetZoom(true); break;
      }
    }
    document.addEventListener('keydown', onKey);

    // ── Scroll wheel ──
    content.addEventListener('wheel', function (e) {
      var img = getActiveImg();
      if (!img) return;
      e.preventDefault();
      var delta = e.deltaY < 0 ? ZOOM_STEP : -ZOOM_STEP;
      zoomTo(scale + delta, e.clientX, e.clientY, false);
    }, { passive: false });

    // ── Click to toggle zoom ──
    content.addEventListener('click', function (e) {
      if (isPanning || swiping) return;
      var img = e.target.closest('img');
      if (!img) return;
      if (scale > 1) resetZoom(true);
      else zoomTo(2.5, e.clientX, e.clientY, true);
    });

    // ── Mouse drag ──
    content.addEventListener('mousedown', function (e) {
      var img = e.target.closest('img');
      if (!img || scale <= 1) return;
      isPanning = false;
      startX = e.clientX; startY = e.clientY;
      startPanX = panX; startPanY = panY;
      img.style.cursor = 'grabbing';
      e.preventDefault();

      function onMove(ev) {
        var dx = ev.clientX - startX, dy = ev.clientY - startY;
        if (Math.abs(dx) > 3 || Math.abs(dy) > 3) isPanning = true;
        panX = startPanX + dx; panY = startPanY + dy;
        clampPan(img); applyTransform(img);
      }
      function onUp() {
        document.removeEventListener('mousemove', onMove);
        document.removeEventListener('mouseup', onUp);
        img.style.cursor = '';
        setTimeout(function () { isPanning = false; }, 10);
      }
      document.addEventListener('mousemove', onMove);
      document.addEventListener('mouseup', onUp);
    });

    // ── Touch: pinch, double-tap, drag, swipe nav ──
    function dist(a, b) { return Math.hypot(b.clientX - a.clientX, b.clientY - a.clientY); }
    function center(a, b) { return { x: (a.clientX + b.clientX) / 2, y: (a.clientY + b.clientY) / 2 }; }

    content.addEventListener('touchstart', function (e) {
      var img = getActiveImg();
      if (!img) return;
      if (e.touches.length === 2) {
        e.preventDefault();
        pinchDist0 = dist(e.touches[0], e.touches[1]);
        pinchScale0 = scale;
        swiping = false;
      } else if (e.touches.length === 1) {
        var now = Date.now();
        if (now - lastTap < DBL_TAP) {
          e.preventDefault();
          if (scale > 1) resetZoom(true);
          else zoomTo(2.5, e.touches[0].clientX, e.touches[0].clientY, true);
          lastTap = 0;
          return;
        }
        lastTap = now;
        startX = e.touches[0].clientX; startY = e.touches[0].clientY;
        startPanX = panX; startPanY = panY;
        swipeStartX = e.touches[0].clientX;
        swipeStartY = e.touches[0].clientY;
        swiping = false;
      }
    }, { passive: false });

    content.addEventListener('touchmove', function (e) {
      var img = getActiveImg();
      if (!img) return;
      if (e.touches.length === 2) {
        e.preventDefault();
        var d = dist(e.touches[0], e.touches[1]);
        var c = center(e.touches[0], e.touches[1]);
        var ns = Math.max(MIN_SCALE, Math.min(MAX_SCALE, pinchScale0 * (d / pinchDist0)));
        var old = scale; scale = ns;
        if (scale <= 1) { panX = 0; panY = 0; }
        else {
          var r = img.getBoundingClientRect();
          var ox = c.x - r.left - r.width / 2;
          var oy = c.y - r.top - r.height / 2;
          var ratio = 1 - scale / old;
          panX += ox * ratio; panY += oy * ratio;
        }
        clampPan(img); applyTransform(img);
      } else if (e.touches.length === 1) {
        if (scale > 1) {
          e.preventDefault();
          panX = startPanX + (e.touches[0].clientX - startX);
          panY = startPanY + (e.touches[0].clientY - startY);
          clampPan(img); applyTransform(img);
        } else {
          // Swipe detection for navigation
          var dx = e.touches[0].clientX - swipeStartX;
          var dy = e.touches[0].clientY - swipeStartY;
          if (Math.abs(dx) > 30 && Math.abs(dx) > Math.abs(dy) * 1.5) swiping = true;
        }
      }
    }, { passive: false });

    content.addEventListener('touchend', function (e) {
      if (swiping && scale <= 1) {
        var dx = e.changedTouches[0].clientX - swipeStartX;
        if (dx > 50) goPrev();
        else if (dx < -50) goNext();
      }
      swiping = false;
      pinchDist0 = 0;
    });

    // ── Open/close hooks ──
    var obs = new MutationObserver(function (muts) {
      muts.forEach(function (m) {
        if (m.attributeName === 'open') {
          if (modal.hasAttribute('open')) {
            resetZoom(false);
            updateCounter();
            // Fade keyboard hint
            if (hintEl) {
              hintEl.classList.remove('fade-out');
              setTimeout(function () { hintEl.classList.add('fade-out'); }, 4000);
            }
          } else {
            resetZoom(false);
          }
        }
      });
    });
    obs.observe(modal, { attributes: true });
  }

  // ── Bootstrap ──
  function hookAll() {
    document.querySelectorAll('product-modal').forEach(function (m) { initViewer(m); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', hookAll);
  else hookAll();

  // Dynamic content fallback
  new MutationObserver(function () {
    document.querySelectorAll('product-modal:not([data-viewer-init])').forEach(function (m) {
      m.setAttribute('data-viewer-init', '');
      initViewer(m);
    });
  }).observe(document.body, { childList: true, subtree: true });
})();
